import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=3bebcc78"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=3bebcc78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports